var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    {
      staticClass: "c-icon",
      attrs: {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 263.09 496.18"
      }
    },
    [
      _c("line", {
        staticClass: "c-icon__line c-icon__line--thick",
        attrs: { x1: "15", y1: "248.09", x2: "248.09", y2: "15" }
      }),
      _vm._v(" "),
      _c("line", {
        staticClass: "c-icon__line c-icon__line--thick",
        attrs: { x1: "15", y1: "248.09", x2: "248.09", y2: "481.18" }
      })
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }